export const FULL_SIZE_ITEMS_YOU_VE_SAMPLED_ANALYTICS_EVENT = {
  DRAWER_MENU_VIEW_ITEMS_I_VE_SAMPLED: 'DRAWER_MENU_VIEW_ITEMS_I_VE_SAMPLED',
  DESKTOP_DRAWER_MENU_VIEW_ITEMS_I_VE_SAMPLED: 'DESKTOP_DRAWER_MENU_VIEW_ITEMS_I_VE_SAMPLED'
}
export const THE_FULL_SIZE_ITEMS_YOU_VE_SAMPLED_URL = '/pages/get-the-full-size-of-items-you-ve-sampled'
export const ITEMS_I_HAVE_SAMPLED_LABEL = 'Items I’ve sampled'
